var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "securities_CustomCases"
  }, [_c("section", [_c("div", {
    staticClass: "bg-main"
  }, [_c("Title", {
    attrs: {
      title: "客户案例"
    }
  })], 1), _c("div", {
    staticClass: "cuscases_content_text"
  }, [_vm._v(_vm._s(_vm.content))]), _c("div", {
    staticClass: "case-content"
  }, _vm._l(_vm.itemList, function (item) {
    return _c("div", {
      key: item.title,
      staticClass: "case-list"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    }), _c("div", {
      staticClass: "case-list-main"
    }, [_c("p", {
      staticClass: "case-list-num"
    }, [_vm._v(_vm._s(item.desc))]), _c("p", {
      staticClass: "case-list-desc"
    }, [_vm._v(_vm._s(item.title))])])]);
  }), 0)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };